export function downloadPdf(){
    var element = document.getElementById('cef-site-content');
    let padding = 90;
    let format = 'a2';
    if(window.innerWidth < 993 ){
        padding = 48;
        format = 'a4';
    }
    var opt = {
        margin:       1,
        filename:     document.title+'.pdf',
        image:        { type: 'jpeg', quality: 0.98 },
        html2canvas:  {scrollY:0,y:padding},
        jsPDF:        { 
                        orientation: 'p',
                        unit: 'mm',
                        format: format,
                        //putOnlyUsedFonts:true,
                        //floatPrecision: 16 // or "smart", default is 16 
                    }
        };

    // New Promise-based usage:
    html2pdf().set(opt).from(element).save();
}